export enum TenantOptions {
  CREDIT_NEW_CREDIT_ANALYSIS = 'credit.newCreditAnalysis',
  CREDIT_WALLET_REPORT = 'credit.walletReport',
  BILLING_ANALYST_NEW_DASHBOARD = 'billingAnalyst.newDashboard',
  CREDIT_RATING = 'credit.rating',
  CREDIT_EASY_CREDIT_SIMULATION = 'credit.easyCreditSimulation',
  CREDIT_TRADE_BILL = 'credit.tradeBill',
  RISK_MANAGEMENT_AREA_ANALYSIS = 'riskManagement.areaAnalysis',
  CREDIT_INSTANT_CREDIT = 'credit.instantCredit',
  CREDIT_PRODUCER_CREDIT_ANALYSES = 'credit.producerCreditAnalyses',
  CREDIT_PROPOSAL_MANAGEMENT = 'credit.proposalManagement',
  CREDIT_FORMALIZATION = 'credit.formalization',
  CREDIT_CPRF_WITHOUT_PLEDGE = 'credit.cprfWithoutPledge',
  CREDIT_CHECKUP = 'credit.checkup',
  CREDIT_EASY_CREDIT = 'credit.easyCredit',
  CREDIT_PAYER = 'credit.payer',
  CREDIT_PRODUCER_MANAGEMENT = 'credit.producerManagement',
  BILLING_ANALYST_PREFIN_LIGHT = 'billingAnalyst.prefinLight',
  CREDIT_CPRF_WITH_PLEDGE = 'credit.cprfWithPledge',
  CREDIT_REGISTRATION = 'credit.registration',
  PLATFORM_HEADER_BANNER = 'platform.headerBanner',
  RISK_MANAGEMENT_MONITORED_OPERATIONS = 'riskManagement.monitoredOperations',
  CREDIT_NEW_ENDORSED = 'credit.newEndorsed',
  RISK_MANAGEMENT_OPERATIONS_REGISTER = 'riskManagement.operationsRegister',
  CREDIT_COMPOSE_COLLATERAL = 'credit.composeCollateral',
  OPERATION_NOTIFICATION = 'operation.notification',
  BILLING_ANALYST_PREFIN_LITE = 'billingAnalyst.prefinLite',
  CREDIT_PROMISSORY_NOTE = 'credit.promissoryNote',
  CREDIT_AGROGALAXY_NP = 'credit.agrogalaxyNP',
  RISK_MANAGEMENT_HISTORICAL_ANALYSIS = 'riskManagement.historicalAnalysis',
  RISK_MANAGEMENT_LAUDO_TECNICO = 'riskManagement.appraisal',
}

export type TenantOptionsValidationMode = 'any' | 'all';
